export const REGIONS = ['americas', 'apac', 'emea', 'global_affinity'];
export const REGION_LABELS = {
    americas: 'Americas',
    apac: 'APAC',
    emea: 'EMEA',
    global_affinity: 'Global Affinity',
};
export const COUNTRY_TO_REGION = {
    US: 'americas', CA: 'americas', MX: 'americas',
    BZ: 'americas', CR: 'americas', SV: 'americas', GT: 'americas', HN: 'americas', NI: 'americas', PA: 'americas',
    AG: 'americas', AI: 'americas', AW: 'americas', BB: 'americas', BL: 'americas', BM: 'americas', BQ: 'americas',
    BS: 'americas', CU: 'americas', CW: 'americas', DM: 'americas', DO: 'americas', GD: 'americas', GP: 'americas',
    HT: 'americas', JM: 'americas', KN: 'americas', KY: 'americas', LC: 'americas', MF: 'americas', MQ: 'americas',
    MS: 'americas', PR: 'americas', SX: 'americas', TC: 'americas', TT: 'americas', VC: 'americas', VG: 'americas', VI: 'americas',
    AR: 'americas', BO: 'americas', BR: 'americas', CL: 'americas', CO: 'americas', EC: 'americas', FK: 'americas',
    GF: 'americas', GY: 'americas', PE: 'americas', PY: 'americas', SR: 'americas', UY: 'americas', VE: 'americas',
    GL: 'americas', PM: 'americas', GS: 'americas',
    AD: 'emea', AT: 'emea', BE: 'emea', CH: 'emea', DE: 'emea', ES: 'emea', FR: 'emea', GB: 'emea', GI: 'emea',
    IE: 'emea', IM: 'emea', IT: 'emea', JE: 'emea', GG: 'emea', LI: 'emea', LU: 'emea', MC: 'emea', MT: 'emea',
    NL: 'emea', PT: 'emea', SM: 'emea', VA: 'emea',
    AX: 'emea', DK: 'emea', EE: 'emea', FI: 'emea', FO: 'emea', IS: 'emea', LT: 'emea', LV: 'emea', NO: 'emea',
    SE: 'emea', SJ: 'emea',
    BG: 'emea', BY: 'emea', CZ: 'emea', HU: 'emea', MD: 'emea', PL: 'emea', RO: 'emea', RU: 'emea', SK: 'emea', UA: 'emea',
    AL: 'emea', BA: 'emea', CY: 'emea', GR: 'emea', HR: 'emea', ME: 'emea', MK: 'emea', RS: 'emea', SI: 'emea', XK: 'emea',
    AE: 'emea', AM: 'emea', AZ: 'emea', BH: 'emea', GE: 'emea', IL: 'emea', IQ: 'emea', IR: 'emea', JO: 'emea',
    KW: 'emea', LB: 'emea', OM: 'emea', PS: 'emea', QA: 'emea', SA: 'emea', SY: 'emea', TR: 'emea', YE: 'emea',
    DZ: 'emea', EG: 'emea', EH: 'emea', LY: 'emea', MA: 'emea', SD: 'emea', TN: 'emea',
    AO: 'emea', BF: 'emea', BI: 'emea', BJ: 'emea', BW: 'emea', CD: 'emea', CF: 'emea', CG: 'emea', CI: 'emea',
    CM: 'emea', CV: 'emea', DJ: 'emea', ER: 'emea', ET: 'emea', GA: 'emea', GH: 'emea', GM: 'emea', GN: 'emea',
    GQ: 'emea', GW: 'emea', KE: 'emea', KM: 'emea', LR: 'emea', LS: 'emea', MG: 'emea', ML: 'emea', MR: 'emea',
    MU: 'emea', MW: 'emea', MZ: 'emea', NA: 'emea', NE: 'emea', NG: 'emea', RE: 'emea', RW: 'emea', SC: 'emea',
    SH: 'emea', SL: 'emea', SN: 'emea', SO: 'emea', SS: 'emea', ST: 'emea', SZ: 'emea', TD: 'emea', TG: 'emea',
    TZ: 'emea', UG: 'emea', YT: 'emea', ZA: 'emea', ZM: 'emea', ZW: 'emea',
    CN: 'apac', HK: 'apac', JP: 'apac', KP: 'apac', KR: 'apac', MN: 'apac', MO: 'apac', TW: 'apac',
    BN: 'apac', ID: 'apac', KH: 'apac', LA: 'apac', MM: 'apac', MY: 'apac', PH: 'apac', SG: 'apac', TH: 'apac', TL: 'apac', VN: 'apac',
    AF: 'apac', BD: 'apac', BT: 'apac', IN: 'apac', LK: 'apac', MV: 'apac', NP: 'apac', PK: 'apac',
    KG: 'apac', KZ: 'apac', TJ: 'apac', TM: 'apac', UZ: 'apac',
    AS: 'apac', AU: 'apac', CK: 'apac', FJ: 'apac', FM: 'apac', GU: 'apac', KI: 'apac', MH: 'apac', MP: 'apac',
    NC: 'apac', NF: 'apac', NR: 'apac', NU: 'apac', NZ: 'apac', PF: 'apac', PG: 'apac', PN: 'apac', PW: 'apac',
    SB: 'apac', TK: 'apac', TO: 'apac', TV: 'apac', VU: 'apac', WF: 'apac', WS: 'apac',
    CC: 'apac', CX: 'apac', IO: 'apac',
};
export function regionForCountry(countryCode) {
    if (!countryCode)
        return 'global_affinity';
    return COUNTRY_TO_REGION[countryCode.toUpperCase()] ?? 'global_affinity';
}
// Inverse of COUNTRY_TO_REGION — every region maps to its country list.
// Used at the SQL layer to translate a region filter into an `IN (...)`
// predicate over `country_code`, now that the materialized `region`
// column is gone (see migration 0031).
export const COUNTRIES_BY_REGION = (() => {
    const out = {
        americas: [],
        apac: [],
        emea: [],
    };
    for (const [code, region] of Object.entries(COUNTRY_TO_REGION)) {
        out[region].push(code);
    }
    return out;
})();
export const ALL_MAPPED_COUNTRY_CODES = Object.keys(COUNTRY_TO_REGION);
//# sourceMappingURL=region.js.map